/**
 * The per-row verdict cell in an import preview table: an icon, a word, and
 * the full explanation on hover.
 */
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

/** Verdict tone, flattened from each dialog's own status union. */
export type RowStatusTone = "valid" | "duplicate" | "invalid";

interface RowStatusBadgeProps {
  tone: RowStatusTone;
  /** What a duplicate is duplicated on, e.g. "Duplicate GSTIN". */
  duplicateLabel: string;
  /** Full explanation, surfaced as the title attribute. */
  message: string;
}

export function RowStatusBadge({ tone, duplicateLabel, message }: RowStatusBadgeProps) {
  return (
    <span title={message} className="inline-flex items-center gap-1">
      {tone === "valid" ? (
        <>
          <CheckCircle2 size={12} className="text-ok" aria-hidden />
          Ready
        </>
      ) : tone === "duplicate" ? (
        <>
          <AlertTriangle size={12} className="text-warn" aria-hidden />
          {duplicateLabel}
        </>
      ) : (
        <>
          <XCircle size={12} className="text-bad" aria-hidden />
          Invalid
        </>
      )}
    </span>
  );
}
